import { memo, MouseEvent } from 'react';
import View from '@picsart/view/View';

import useBatchData from 'pages/Batch/sections/Context/useBatchData';
import DropImage from 'pages/Batch/components/DropImage';
import useFileUploader from 'hooks/useFileUploader';
import { ALLOWED_LIMIT_FILES, BATCH_TOOLS } from 'pages/Batch/configs';
import analytics from 'pages/Batch/utils/analytics';

import useStyles from './styles';
import testIds from './testIds';

const EmptyMain = () => {
  const { acceptFiles } = useBatchData();
  const classes = useStyles();

  const { inputProps, rootProps, handleUploadClick } = useFileUploader({
    maxCount: ALLOWED_LIMIT_FILES,
    onFileUploadDone: acceptFiles,
  });

  const handleClick = async (ev: MouseEvent<HTMLElement>) => {
    analytics.clickEvent(BATCH_TOOLS.upload);
    await handleUploadClick(ev);
  };

  return (
    <View
      {...rootProps}
      className={classes.wrapper}
      dataTestId={testIds.wrapper}
      onClick={handleClick}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <input {...inputProps} data-testid={testIds.input} />

      <DropImage />
    </View>
  );
};

export default memo(EmptyMain);
